module.exports = __webpack_public_path__ + "static/kid@large-76d5ae0d9b3f2c14df70fa8299145f65.jpg";